const translation = {
  Product: "Produk",
  "Header.productNav": "Produk LUKKEY",
  Feature: "Fitur",
  "About Us": "Tentang Kami",
  FAQ: "FAQ",
  "Privacy Policy": "Kebijakan Privasi",
  "Help Center": "Pusat Bantuan",
  "Header.infoMenu": "Lainnya",
  "Header.appNow": "Dapatkan aplikasi",
  "Header.appModal.title": "Gunakan aplikasi LUKKEY sekarang",
  "Header.appModal.subtitle": "Pilih platform Anda untuk mendapatkan aplikasi mobile resmi LUKKEY.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Instal aplikasi resmi di iPhone.",
  "Header.appModal.iosButton": "Buka",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Dapatkan aplikasi Android resmi di Google Play.",
  "Header.appModal.googlePlayButton": "Buka",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Unduh APK resmi terbaru secara langsung.",
  "Header.appModal.androidButton": "Unduh",
  "Header.appModal.note": "Hanya unduhan mobile resmi. Gunakan tautan di atas untuk versi terbaru.",
  "Academy": "Akademi",
  "Legal": "Informasi Legal",
  "AboutUs.title": "Tentang LUKKEY",
  "AboutUs.lede": "LUKKEY adalah merek dompet perangkat keras asal Swiss yang berdedikasi membangun standar keamanan tertinggi untuk kepemilikan aset digital.",
  "AboutUs.vision.closing": "Kunci Anda. Aset Anda. Masa depan Anda.",
  "AboutUs.quote": "LUKKEY membangun lapisan keamanan antara manusia dan aset digital.",
  "AboutUs.block1": "LUKKEY berbasis di Swiss. Perusahaan ini berfokus pada dompet perangkat keras yang dirancang untuk self-custody yang aman.",
  "AboutUs.block2": "Produknya menggabungkan secure element, perlindungan anti-rusak, dan arsitektur yang sepenuhnya offline. Tujuannya adalah menjaga private key tetap berada di lingkungan yang terisolasi.",
  "AboutUs.block3": "Sistem ini dirancang tanpa Wi‑Fi, USB, atau ketergantungan jaringan langsung. Akses sidik jari, alat cadangan NFC, dan dukungan aset yang luas membuatnya praktis untuk penggunaan sehari-hari.",
  "AboutUs.block5": "LUKKEY mengikuti pendekatan terbuka dan dapat diaudit untuk firmware dan perangkat lunak inti. Klaim keamanan harus tetap dapat diperiksa dan diverifikasi.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Permintaan dukungan",
  "WarrantySupport.intro": "Silakan isi informasi di bawah ini untuk mengirim permintaan dukungan Anda.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Ringkasan masalah",
  "WarrantySupport.form.issueTitle.placeholder": "Masukkan ringkasan singkat",
  "WarrantySupport.form.warrantyType.label": "Jenis permintaan",
  "WarrantySupport.form.warrantyType.placeholder": "Pilih jenis permintaan",
  "WarrantySupport.form.warrantyType.product": "Masalah perangkat",
  "WarrantySupport.form.warrantyType.service": "Masalah aplikasi/akun",
  "WarrantySupport.form.warrantyType.replacement": "Lainnya",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Jelaskan masalah atau permintaan secara rinci",
  "WarrantySupport.form.submit": "Kirim permintaan dukungan",
  "WarrantySupport.alert.success": "Permintaan dukungan Anda telah dikirim!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Pusat Bantuan",
  "HelpCenter.intro":
    "Selamat datang di Pusat Bantuan LUKKEY! Jika Anda baru dalam dunia kripto atau membutuhkan bantuan dengan cold wallet Anda, Anda berada di tempat yang tepat. Solusi cold wallet kami menyediakan cara paling aman untuk menyimpan dan mengelola aset digital Anda. Di bawah ini Anda akan menemukan jawaban atas pertanyaan umum serta tips pemecahan masalah.",
  "HelpCenter.section4.title": "Butuh bantuan tambahan?",
  "HelpCenter.section4.intro":
    "Hemat waktu dengan memulai permintaan dukungan secara online, dan kami akan menghubungkan Anda dengan spesialis. Demi keamanan, dukungan resmi tidak akan pernah meminta frasa pemulihan atau kunci privat Anda:",
  "HelpCenter.contact.hint": "Gunakan tombol untuk mengirim permintaan dukungan dan kami akan menghubungi Anda lewat email.",
  "HelpCenter.cta.warranty": "Kirim permintaan dukungan",
  brandName: "LUKKEY",
  tagline: "Kelola Crypto Anda Seperti Tidak Pernah Sebelumnya",
  description:
    "Mulai perjalanan Anda menuju kebebasan finansial dengan aplikasi kami. Amankan aset Anda dengan teknologi dompet dingin canggih kami, dan kelola keuangan Anda dengan lebih cerdas dan efektif. Kesejahteraan finansial Anda adalah prioritas utama kami.",
  "home.seoTitle": "LUKKEY | Dompet hardware Swiss untuk self-custody yang aman",
  "home.seoDescription": "LUKKEY adalah merek dompet hardware asal Swiss yang berfokus pada keamanan cold wallet, perlindungan offline untuk private key, akses sidik jari, dan backup NFC untuk self-custody yang aman.",
  learnMore: "Pelajari lebih lanjut",
  "Lock Your Crypto, Securely": "Kunci Crypto Anda dengan Aman",
  Testimonials: "Testimoni",
  Testimonial1:
    "Saya telah menggunakan dompet dingin ini selama berbulan-bulan dan saya terkesan dengan keandalan dan fitur keamanannya. Sangat direkomendasikan!",
  Testimonial2:
    "Dompet dingin ini melebihi ekspektasi saya! Antarmuka yang mudah digunakan dan keamanan tingkat tinggi membuatnya menjadi alat yang wajib dimiliki bagi siapa saja yang serius dengan crypto.",
  Testimonial3:
    "Saya telah mencoba beberapa dompet dingin sebelumnya, tetapi yang ini menonjol. Desain ramping dan fitur-fitur canggih membuat mengelola aset crypto saya sangat mudah.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Pecinta cryptocurrency",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Advokat Keamanan Crypto",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Analis Investasi",
  "Touchscreen Interface": "Antarmuka layar sentuh",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Rasakan kemudahan manajemen kripto dengan antarmuka layar sentuh intuitif kami, yang dirancang untuk navigasi cepat dan mudah melalui aset digital Anda, memungkinkan transaksi cepat dan manajemen yang aman di ujung jari Anda.",
  "Bluetooth Connectivity": "Konektivitas Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Sinkronisasi nirkabel dengan perangkat Anda untuk pembaruan waktu nyata.",
  "Airtag Tracking": "Pelacakan Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Lacak dompet Anda dengan mudah menggunakan Airtag bawaan.",
  "Secure Chip Technology": "Teknologi chip aman",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Dilengkapi dengan chip keamanan canggih, memastikan perlindungan kuat untuk aset digital Anda yang berharga dari akses tidak sah dan ancaman siber.",
  "Cross-Platform Support": "Dukungan lintas platform",
  "Works with various platforms for easy accessibility.":
    "Bekerja dengan berbagai platform untuk kemudahan akses.",
  AboutUsDescription1:
    "Di LUKKEY, kami berkomitmen untuk memberikan solusi berkualitas tinggi untuk mengelola aset kripto Anda dengan aman.",
  AboutUsDescription2:
    "Kantor pusat kami berada di Zug, Swiss. Dengan tim profesional berpengalaman, kami berusaha untuk berinovasi dan beradaptasi dengan pasar mata uang digital yang terus berkembang.",
  BlockchainNetworksSupported: "Jaringan Blockchain yang Didukung",
  CryptocurrenciesSupported: "Mendukung Lebih dari 6.000 Cryptocurrency",
  Years: "Tahun",
  ExpertiseInSecurity: "pengalaman dalam Keamanan",
  FrequentlyAskedQuestions: "Pertanyaan yang sering diajukan",
  WhatIsColdWallet: "Apa itu Cold Wallet?",
  ColdWalletDescription:
    "Cold Wallet adalah jenis dompet cryptocurrency yang menyimpan aset digital Anda secara offline, membuatnya lebih aman dari peretasan dan ancaman online lainnya. Berbeda dengan hot wallet, yang terhubung ke internet dan nyaman untuk transaksi sering, cold wallet lebih cocok untuk penyimpanan jangka panjang karena memberikan keamanan yang lebih tinggi.",
  HowToSetUpColdWallet: "Bagaimana cara mengatur Cold Wallet Anda?",
  ColdWalletSetupDescription:
    "Mengatur Cold Wallet Anda biasanya melibatkan menginisialisasi perangkat di mesin yang aman dan offline. Anda perlu menghasilkan dan menyimpan frase pemulihan dengan aman, yang penting untuk mengakses aset Anda jika perangkat hilang atau rusak. Petunjuk rinci disediakan dengan pembelian Anda untuk memastikan proses pengaturan berjalan lancar.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Cryptocurrency apa saja yang kompatibel dengan cold wallet Anda?",
  CryptocurrenciesCompatibilityDescription:
    "Cold Wallet kami mendukung berbagai cryptocurrency, termasuk yang utama seperti Bitcoin, Ethereum, dan Litecoin, serta berbagai altcoin. Untuk daftar lengkap mata uang yang didukung, silakan kunjungi situs web kami atau lihat dokumentasi produk.",
  HowToSecureColdWallet: "Bagaimana cara memastikan Cold Wallet saya aman?",
  ColdWalletSecurityDescription:
    "Untuk mengamankan Cold Wallet Anda, selalu simpan frase pemulihan di tempat yang aman dan pribadi, jangan membagikannya dengan siapa pun, dan pertimbangkan untuk menggunakan langkah-langkah keamanan tambahan seperti kunci biometrik atau wadah aman. Memperbarui firmware wallet secara teratur dari situs web resmi juga membantu melindungi dari kerentanannya.",
  ColdWalletNotWorking:
    "Apa yang harus saya lakukan jika Cold Wallet saya tidak berfungsi atau jika saya mengalami kesalahan?",
  ColdWalletErrorDescription:
    "Jika Anda mengalami masalah dengan Cold Wallet Anda, rujuk ke bagian pemecahan masalah di panduan pengguna kami. Untuk masalah yang lebih spesifik, hubungi tim dukungan kami melalui situs web kami. Pastikan Anda memiliki informasi perangkat Anda untuk mempercepat proses dukungan.",
  Community: "Komunitas",
  "Subscribe.title": "Dapatkan pembaruan produk",
  "Subscribe.subtitle":
    "Kami memantau tren kripto untuk Anda. Dapatkan pembaruan produk, wawasan pasar, dan keuntungan eksklusif — langsung ke kotak masuk Anda.",
  "Subscribe.placeholder": "Masukkan email Anda",
  "Subscribe.button": "Berlangganan pembaruan produk",
  "Subscribe.input.aria": "Kolom input alamat email",
  "Subscribe.success":
    "Terima kasih telah berlangganan! Silakan cek email konfirmasi Anda.",
  "Subscribe.error": "Gagal berlangganan. Silakan coba lagi nanti.",
  "Subscribe.invalid": "Harap masukkan alamat email yang valid.",
  "Subscribe.privacy":
    "Email Anda hanya akan digunakan untuk mengirim buletin dan pembaruan kami. Anda dapat berhenti berlangganan kapan saja melalui tautan dalam email.",
  "Subscribe.learnMore":
    "Pelajari lebih lanjut tentang cara kami mengelola data dan hak Anda.",
  "Subscribe.popupCompact.title": "Tetap terbarui",
  "Subscribe.popupCompact.subtitle":
    "Pembaruan produk dan wawasan keamanan. Tanpa spam.",
  "Subscribe.popupCompact.button": "Berlangganan",
  "Subscribe.popupCompact.privacy":
    "Hanya email. Bisa berhenti kapan saja.",
  "SubscribeConfirmed.alt.success": "Langganan Dikonfirmasi",
  "SubscribeConfirmed.alt.failed": "Langganan Gagal",
  "SubscribeConfirmed.title.success": "Langganan Dikonfirmasi",
  "SubscribeConfirmed.title.failed": "Langganan Gagal",
  "SubscribeConfirmed.message.success":
    "Terima kasih telah mengonfirmasi email Anda. Langganan Anda sekarang aktif. Email sambutan telah dikirim ke kotak masuk Anda.",
  "SubscribeConfirmed.message.failed":
    "Tautan konfirmasi tidak valid atau telah kedaluwarsa. Silakan kembali ke beranda dan coba berlangganan lagi.",
  "SubscribeConfirmed.cta.backHome": "Kembali ke Beranda",
  "SubscribeConfirmed.note.unsubscribe":
    "Anda dapat berhenti berlangganan kapan saja melalui tautan di email kami.",
  // ===== MarketView i18n =====
  "MarketView.title": "Dasbor Pasar",
  "MarketView.loading": "Memuat...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Tab ini gagal dirender",
  "MarketView.unknownError": "Kesalahan tidak diketahui",

  // ===== Common i18n =====
  "Common.refresh": "Segarkan",
  "Common.toggleSeriesVisibility": "Alihkan seri ini",
  "Common.error": "Kesalahan",
  "Common.dataUpdateTime": "Waktu Pembaruan Data",
  "Common.loading": "Memuat...",
  "Common.noDataSource": "Tidak ada data (sumber data tidak disediakan)",

  // ===== Common ranges =====
  "Common.to": "sampai",
  "Common.clear": "Bersihkan",
  "Common.range.thisMonth": "Bulan ini",
  "Common.range.lastMonth": "Bulan lalu",
  "Common.range.last2": "2 Bulan Terakhir",
  "Common.range.last3": "3 Bulan Terakhir",
  "Common.range.last6": "6 Bulan Terakhir",
  "Common.range.thisYear": "Tahun ini",
  "Common.range.all": "Semua",
  "Common.range.custom": "Kustom",
  "Common.showFilters": "Tampilkan filter",
  "Common.hideFilters": "Sembunyikan filter",
  "Common.search": "Cari",
  "Common.priority": "Prioritas",
  "Common.owner": "Penanggung jawab",
  "Common.collaborator": "Kolaborator",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Unduh backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Unduh youtube_stats.json",
  "YouTubeTab.loading": "Memuat metrik YouTube...",
  "YouTubeTab.errorHint":
    "Jika kunci API belum dikonfigurasi, setel YOUTUBE_API_KEY atau GOOGLE_API_KEY di backend/.env dan mulai ulang backend.",
  "YouTubeTab.header.totalViews": "Total Tayangan (Multi-kanal, Satuan: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Total Pelanggan (Multi-kanal, Satuan: 10k)",
  "YouTubeTab.dist.views": "Distribusi Tayangan (10k)",
  "YouTubeTab.dist.subscribers": "Distribusi Pelanggan (10k)",
  "YouTubeTab.card.location": "Lokasi:",
  "YouTubeTab.card.registeredAt": "Terdaftar pada:",
  "YouTubeTab.card.currentSubscribers": "Pelanggan Saat Ini",
  "YouTubeTab.card.currentVideos": "Jumlah Video Saat Ini",
  "YouTubeTab.card.currentTotalViews": "Total Tayangan Saat Ini",
  "YouTubeTab.card.currentTotalComments": "Total Komentar Saat Ini",
  "YouTubeTab.chart.totalSubscribers": "Total Pelanggan",
  "YouTubeTab.chart.totalViews": "Total Tayangan",
  "YouTubeTab.chart.totalComments": "Total Komentar",
  "YouTubeTab.chart.totalVideos": "Total Video",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Unduh backend data/x_stats.json",
  "XTab.downloadJson": "Unduh x_stats.json",
  "XTab.loading": "Memuat metrik X...",
  "XTab.errorHint":
    "Jika token belum dikonfigurasi, setel X_BEARER_TOKEN atau TWITTER_BEARER_TOKEN di backend/.env dan mulai ulang backend.",
  "XTab.header.totalFollowers": "Total Pengikut (Multi-kanal, Satuan: 10k)",
  "XTab.header.totalEngagement":
    "Total Keterlibatan (5 posting terakhir: Suka + Retweet + Balasan + Kutipan, Satuan: 10k)",
  "XTab.dist.followers": "Distribusi Pengikut (10k)",
  "XTab.dist.engagement":
    "Distribusi Keterlibatan (5 posting terakhir: Suka + Retweet + Balasan + Kutipan, Satuan: 10k)",
  "XTab.card.currentFollowers": "Pengikut Saat Ini",
  "XTab.card.currentFollowing": "Mengikuti Saat Ini",
  "XTab.card.currentTweets": "Jumlah Tweet Saat Ini",
  "XTab.card.recentLikes": "Suka Terbaru (5 posting terakhir)",
  "XTab.card.recentRetweets": "Retweet Terbaru (5 posting terakhir)",
  "XTab.card.recentReplies": "Balasan Terbaru (5 posting terakhir)",
  "XTab.card.recentQuotes":
    "Tayangan Terbaru (level konten, 5 posting terakhir)",
  "XTab.card.listed": "Jumlah terdaftar (level kanal)",
  "XTab.smallChart.followers": "Pengikut",
  "XTab.smallChart.tweets": "Tweet",
  "XTab.smallChart.likes": "Suka Terbaru",
  "XTab.smallChart.retweets": "Retweet Terbaru",
  "XTab.smallChart.replies": "Balasan Terbaru",
  "XTab.smallChart.quotes": "Tayangan Terbaru (level konten)",
  "XTab.smallChart.following": "Mengikuti",
  "XTab.smallChart.listed": "Terdaftar",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Saring berdasarkan bulan pembuatan:",
  "Analytics.dashboardTitle": "Dasbor Kesehatan Proyek",
  "Analytics.metric.completionRate": "Tingkat Penyelesaian",
  "Analytics.metric.teamVelocity": "Kecepatan Tim",
  "Analytics.metric.blockerRatio": "Rasio Blokir",
  "Analytics.metric.workloadBalance": "Keseimbangan Beban Kerja",
  "Analytics.charts.statusDistribution": "Distribusi Status",
  "Analytics.charts.statusByMonthPercent": "Status per Bulan (Persentase)",
  "Analytics.charts.priorityDistribution": "Distribusi Prioritas",
  "Analytics.charts.priorityByMonthPercent": "Prioritas per Bulan (Persentase)",
  "Analytics.charts.functionTypeDistribution": "Distribusi Jenis Fungsi",
  "Analytics.charts.functionTypeByMonthPercent":
    "Jenis Fungsi per Bulan (Persentase)",
  "Analytics.blocker.ownerPie":
    "Isu Terblokir · Distribusi Penanggung Jawab (Donat)",
  "Analytics.blocker.ownerByMonth":
    "Isu Terblokir · Penanggung Jawab per Bulan (Persentase)",
  "Analytics.bug.ownerPie": "Isu Bug · Distribusi Penanggung Jawab (Donat)",
  "Analytics.bug.ownerByMonth":
    "Isu Bug · Penanggung Jawab per Bulan (Persentase)",
  "Analytics.ownerWorkloadDistribution": "Distribusi Beban Kerja Tim",
  "Analytics.mode.priority": "Distribusi Prioritas",
  "Analytics.mode.status": "Distribusi Status",
  "Analytics.mode.type": "Distribusi Jenis",
  "Analytics.blocker.attentionNeeded": "Isu yang Memerlukan Perhatian Segera",
  "Analytics.common.status": "Status",
  "Analytics.common.owner": "Penanggung jawab",
  "Analytics.insights.sectionTitle": "Wawasan & Rekomendasi Proyek",
  "Analytics.insights.efficiency.title": "Saran Peningkatan Efisiensi",
  "Analytics.insights.efficiency.completionRate":
    "• Tingkat penyelesaian saat ini {{rate}}%, perhatikan blokir",
  "Analytics.insights.efficiency.avgVelocity":
    "• Kecepatan rata-rata tim {{velocity}} tugas/orang",
  "Analytics.insights.efficiency.workloadBalance":
    "• Keseimbangan beban kerja {{balance}}%",
  "Analytics.insights.risk.title": "Peringatan Risiko",
  "Analytics.insights.risk.blockerRatio": "• Rasio blokir {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Rasio isu P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Tangani isu prioritas tinggi terlebih dahulu",

  // ===== Kanban i18n =====
  "Kanban.title": "Tampilan Kanban",
  "Kanban.totalIssues": "Total {{count}} isu",
  "Kanban.searchPlaceholder":
    "Cari judul, nomor isu, penanggung jawab atau kolaborator...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "Sedang Dikerjakan",
  "Kanban.status.blocked": "Diblokir / Menunggu Konfirmasi",
  "Kanban.status.reviewTest": "Ulasan / Tes",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Daftar Isu",
  "List.totalIssues": "Total {{count}} isu",
  "List.viewDetails": "Lihat Detail",
  "List.openInNewWindow": "Buka di jendela baru",
  "List.empty.title": "Tidak ada isu",
  "List.empty.subtitle": "Buat isu pertama untuk memulai alur kerja",

  // ===== Assets Register i18n =====
  "Assets.title": "Registrasi Aset",
  "Assets.totalSets": "Total Set",
  "Assets.table.employee": "Karyawan",
  "Assets.table.setCount": "Set",
  "Assets.table.model": "Model",
  "Assets.total": "Total",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Pelacakan Isu Proyek",
  "LukkeyIssues.goToDemo": "Buka Halaman Demo",
  "LukkeyIssues.githubProject": "Proyek GitHub ↗",
  "LukkeyIssues.githubManageIssues": "Kelola Issues langsung di GitHub ↗",
  "LukkeyIssues.financeModel": "Model Keuangan",
  "LukkeyIssues.productCoreIssues": "Isu Inti Produk",
  "LukkeyIssues.stats.totalIssues": "📊 Total Isu",
  "LukkeyIssues.stats.completed": "✅ Selesai",
  "LukkeyIssues.stats.inProgress": "🔄 Sedang Dikerjakan",
  "LukkeyIssues.stats.pending": "⏳ Tertunda",
  "LukkeyIssues.stats.blocked": "🚫 Diblokir",
  "LukkeyIssues.stats.docs": "📚 Docs",
  "LukkeyIssues.tabs.kanban": "Tampilan Kanban",
  "LukkeyIssues.tabs.analytics": "Analitik",
  "LukkeyIssues.tabs.market": "Dasbor Pasar",
  "LukkeyIssues.tabs.assets": "Registrasi Aset",
  "LukkeyIssues.shareToChatGPT": "Buka LUKKEY.json dengan ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Kebijakan Privasi LUKKEY",
  "PrivacyPolicy.intro.p1":
    "Di LUKKEY, kami percaya bahwa bentuk privasi paling aman adalah yang selalu sepenuhnya berada di tangan pengguna sendiri.",
  "PrivacyPolicy.intro.p2":
    "Oleh karena itu, baik saat Anda menggunakan perangkat dompet dingin (cold wallet) LUKKEY maupun aplikasi seluler LUKKEY (App), kami secara ketat memegang satu prinsip yang tak tergoyahkan:",
  "PrivacyPolicy.intro.p3_strong":
    "Kecuali jika pengguna memberikan izin secara tegas, kami tidak mengumpulkan, menyimpan, atau mengunggah informasi pengguna apa pun.",
  "PrivacyPolicy.intro.p3_tail":
    "Semua data terkait penggunaan hanya disimpan secara lokal pada perangkat pengguna dan tidak pernah dikirim ke LUKKEY atau server mana pun.",
  "PrivacyPolicy.intro.p4":
    "Kebijakan Privasi ini menjelaskan bagaimana kami menegakkan prinsip tersebut.",

  "PrivacyPolicy.s1.title": "1. Ruang Lingkup",
  "PrivacyPolicy.s1.appliesTo": "Kebijakan Privasi ini berlaku untuk:",
  "PrivacyPolicy.s1.item.hardware": "Perangkat dompet dingin (hardware) LUKKEY",
  "PrivacyPolicy.s1.item.app": "Aplikasi seluler LUKKEY (App)",
  "PrivacyPolicy.s1.principle":
    "Keduanya mengikuti prinsip privasi terpadu “tanpa pengumpulan, tanpa unggah, hanya penyimpanan lokal”.",

  "PrivacyPolicy.s2.title": "2. Informasi yang TIDAK Kami Kumpulkan",
  "PrivacyPolicy.s2.desc":
    "Untuk melindungi privasi Anda, kami secara tegas berkomitmen untuk tidak mengumpulkan, mengunggah, atau menyimpan informasi pengguna apa pun, termasuk namun tidak terbatas pada:",
  "PrivacyPolicy.s2.li.identity":
    "Informasi identitas: nama, nomor telepon, alamat email, alamat pos",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Data sensitif dompet: private key, frasa mnemonik, file keystore, kata sandi dompet",
  "PrivacyPolicy.s2.li.blockchain":
    "Data blockchain: alamat dompet, riwayat transaksi, informasi aset",
  "PrivacyPolicy.s2.li.behavior":
    "Perilaku penggunaan: log aplikasi, catatan klik, analitik perilaku",
  "PrivacyPolicy.s2.li.technical":
    "Informasi teknis: pengenal perangkat, lokasi geografis, alamat IP",
  "PrivacyPolicy.s2.inShort.title": "Singkatnya:",
  "PrivacyPolicy.s2.inShort.desc":
    "Segala sesuatu yang Anda lihat di perangkat keras dan di App hanya ada pada perangkat Anda. LUKKEY tidak dapat mengaksesnya.",

  "PrivacyPolicy.s3.title":
    "3. Desain Privasi & Keamanan Dompet Dingin (Hardware)",
  "PrivacyPolicy.s3.desc":
    "Dompet dingin LUKKEY menyediakan lingkungan yang sepenuhnya offline dan aman. Fitur utama:",
  "PrivacyPolicy.s3.h1.title": "1. Perangkat keamanan setara militer",
  "PrivacyPolicy.s3.h1.l1": "Secure Element bersertifikat EAL6+",
  "PrivacyPolicy.s3.h1.l2":
    "Komunikasi terenkripsi di tingkat hardware secara menyeluruh",
  "PrivacyPolicy.s3.h2.title": "2. Fungsi keamanan",
  "PrivacyPolicy.s3.h2.l1": "Autentikasi sidik jari",
  "PrivacyPolicy.s3.h2.l2": "Mode privasi",
  "PrivacyPolicy.s3.h2.l3": "Manajemen multi‑dompet yang terisolasi",
  "PrivacyPolicy.s3.h3.title": "3. Isolasi penuh",
  "PrivacyPolicy.s3.h3.l1": "Tanpa konektivitas Internet",
  "PrivacyPolicy.s3.h3.l2": "Tanpa koneksi kabel data",
  "PrivacyPolicy.s3.h4.title":
    "4. Tahan perusakan dengan penghancuran otomatis",
  "PrivacyPolicy.s3.h4.desc":
    "Jika perangkat dibongkar, rusak, atau mengalami intrusi abnormal, Secure Element secara otomatis menghancurkan data sensitif agar private key tidak dapat diekstrak.",
  "PrivacyPolicy.s3.h5.title":
    "5. Operasi sensitif hanya dilakukan di dalam Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Pembuatan dompet",
  "PrivacyPolicy.s3.h5.l2": "Impor dompet",
  "PrivacyPolicy.s3.h5.l3": "Penandatanganan transaksi",
  "PrivacyPolicy.s3.h5.note":
    "Semua proses sensitif berlangsung 100% di dalam Secure Element, tidak pernah terekspos ke chip atau area penyimpanan yang tidak aman.",
  "PrivacyPolicy.s3.h6.title":
    "6. Tidak ada data sensitif di luar Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "Area penyimpanan yang tidak aman pada perangkat tidak pernah menyimpan private key, frasa mnemonik, atau informasi sensitif apa pun.",

  "PrivacyPolicy.s4.title": "4. Desain Privasi & Keamanan Aplikasi LUKKEY",
  "PrivacyPolicy.s4.desc":
    "Aplikasi LUKKEY hanya berfokus pada penayangan informasi dan pemberitahuan. Aplikasi ini tidak menangani data sensitif dompet.",
  "PrivacyPolicy.s4.n1.title": "1. Hal yang TIDAK dilakukan App",
  "PrivacyPolicy.s4.n1.l1": "Tidak membuat dompet blockchain",
  "PrivacyPolicy.s4.n1.l2": "Tidak mengimpor dompet blockchain",
  "PrivacyPolicy.s4.n1.l3": "Tidak menyimpan private key atau frasa mnemonik",
  "PrivacyPolicy.s4.n1.l4": "Tidak mengunggah data pengguna apa pun",
  "PrivacyPolicy.s4.n1.l5":
    "Tidak melakukan analitik perilaku, pelacakan iklan, atau pengumpulan data",
  "PrivacyPolicy.s4.n2.title": "2. Hal yang dilakukan App",
  "PrivacyPolicy.s4.n2.l1":
    "Menampilkan informasi yang dapat diakses publik dan diotorisasi oleh perangkat keras",
  "PrivacyPolicy.s4.n2.l2":
    "Menyediakan panel pengaturan privasi yang menjelaskan tujuan setiap izin",
  "PrivacyPolicy.s4.n2.l3":
    "Memberi pengguna kontrol penuh untuk mengaktifkan/menonaktifkan izin kapan saja",
  "PrivacyPolicy.s4.n2.l4":
    "Menyediakan penyamaran (masking) informasi sensitif",
  "PrivacyPolicy.s4.n2.l5":
    "Menonaktifkan tangkapan layar/rekaman pada tampilan tertentu",
  "PrivacyPolicy.s4.n2.l6":
    "Mendeteksi alamat blockchain mencurigakan melalui pencocokan lokal",
  "PrivacyPolicy.s4.n2.l7":
    "Memperbarui daftar URL, kontrak, dan alamat berbahaya secara berkala",
  "PrivacyPolicy.s4.n2.l8":
    "Alur pembaruan satu arah: hanya dari server → perangkat",
  "PrivacyPolicy.s4.n2.l9":
    "Tidak ada data pengguna yang pernah dikirim balik selama pembaruan",
  "PrivacyPolicy.s4.n3.title": "3. Penyimpanan lokal",
  "PrivacyPolicy.s4.n3.p1":
    "App hanya menyimpan data non‑pribadi secara lokal, seperti preferensi UI, bahasa, dan pengaturan tema. Data ini:",
  "PrivacyPolicy.s4.n3.l1": "tidak diunggah",
  "PrivacyPolicy.s4.n3.l2": "tidak disinkronkan",
  "PrivacyPolicy.s4.n3.l3": "tidak dapat diakses oleh LUKKEY",

  "PrivacyPolicy.s5.title": "5. Transmisi Data & Kebijakan Server",
  "PrivacyPolicy.s5.l1":
    "Server LUKKEY tidak menyimpan informasi pengguna apa pun",
  "PrivacyPolicy.s5.l2":
    "Komunikasi App–server terbatas pada pembaruan basis data dan versi",
  "PrivacyPolicy.s5.l3":
    "Tidak ada informasi pengguna yang ditransmisikan selama komunikasi",
  "PrivacyPolicy.s5.l4":
    "Bahkan jika terjadi pelanggaran server, tidak ada data pengguna yang dapat terekspos karena kami tidak pernah memperoleh data tersebut sejak awal",

  "PrivacyPolicy.s6.title": "6. Transparansi Sumber Terbuka",
  "PrivacyPolicy.s6.l1": "Kode sumber App LUKKEY bersifat open‑source",
  "PrivacyPolicy.s6.l2":
    "Firmware tertanam pada perangkat keras LUKKEY bersifat open‑source",
  "PrivacyPolicy.s6.l3":
    "Tersedia sepenuhnya di GitHub untuk diaudit oleh siapa saja",
  "PrivacyPolicy.s6.p": "Transparansi adalah bagian dari keamanan.",

  "PrivacyPolicy.s7.title": "7. Kendali Penuh oleh Pengguna",
  "PrivacyPolicy.s7.p":
    "Walaupun kami tidak mengumpulkan informasi pengguna, pengguna tetap memiliki kendali penuh atas perangkat mereka:",
  "PrivacyPolicy.s7.l1": "Anda dapat menonaktifkan izin App kapan saja",
  "PrivacyPolicy.s7.l2":
    "Anda dapat menghapus App untuk membuang semua data App lokal",
  "PrivacyPolicy.s7.l3":
    "Anda dapat mereset perangkat keras untuk menghapus secara permanen private key dan data dompet",
  "PrivacyPolicy.s7.p2":
    "LUKKEY tidak dan tidak dapat campur tangan dalam tindakan tersebut.",

  "PrivacyPolicy.s8.title": "8. Hubungi Kami",
  "PrivacyPolicy.s8.p":
    "Jika Anda memiliki pertanyaan mengenai Kebijakan Privasi ini, silakan hubungi kami:",
  "PrivacyPolicy.s8.email": "Email: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Alamat: Kantor Pusat LUKKEY, Baarerstrasse 25, 6300 Zug, Swiss",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Memeriksa...",
  "EmailOtp.title":
    "Akses terbatas: masukkan nama dan email untuk menerima kode masuk",
  "EmailOtp.nameLabel": "Nama",
  "EmailOtp.namePlaceholder": "Masukkan nama Anda",
  "EmailOtp.emailLabel": "Email",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Kirim kode",
  "EmailOtp.resendCode": "Kirim ulang kode",
  "EmailOtp.resendWithCountdown": "Kirim ulang dalam {{s}} detik",
  "EmailOtp.codeValidityHint":
    "Kode verifikasi berlaku selama 5 menit. Jangan bagikan kepada siapa pun.",
  "EmailOtp.codeLabel": "Kode verifikasi email",
  "EmailOtp.codePlaceholder": "Masukkan kode yang diterima",
  "EmailOtp.signIn": "Masuk",
  "EmailOtp.message.codeSent": "Kode verifikasi telah dikirim ke email Anda.",
  "EmailOtp.error.nameRequired": "Nama wajib diisi",
  "EmailOtp.error.invalidEmail": "Masukkan alamat email yang valid",
  "EmailOtp.error.sendFailed": "Gagal mengirim kode verifikasi",
  "EmailOtp.error.codeRequired": "Masukkan kode verifikasi",
  "EmailOtp.error.verificationFailed": "Verifikasi gagal",
  // ===== Academy i18n =====
  "Academy.hero.alert": "Pengingat Keamanan: Selalu verifikasi tautan dan jangan pernah membagikan frasa pemulihan.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Akademi",
  "Academy.hero.subtitle": "Panduan praktis tentang keamanan kripto, self‑custody, dan penggunaan dompet dingin LUKKEY.",
  "Academy.search.placeholder": "Cari tutorial, praktik terbaik, dan FAQ…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "Artikel",
  "Academy.list.title": "Panduan Terbaru",
  "Academy.list.viewAll": "LIHAT SEMUA",
  "Academy.list.empty": "Tidak ada hasil. Coba kata kunci lain.",
  "Academy.image.placeholder": "GAMBAR",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Kembali ke Akademi",
  "AcademyArticle.notFound": "Artikel tidak ditemukan",
  "AcademyArticle.author": "Penulis",
  "AcademyArticle.unscheduled": "Tidak ada jadwal waktu publikasi",
  "home.hero.reserveCtaLabel": "Akses awal — US$1",
  "home.hero.reserveCtaNote": "Dapat dikembalikan sepenuhnya. Tanpa komitmen pembelian."
};
export default translation;
